import styled from 'styled-components';

export const TitleStyled = styled.p`
  color: ${({ theme }) => theme.palette.blue.h80};
  font-size: 1.25rem;
  font-weight: bold;
`;
